import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const Herosection = () => {
  const textVariant = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
  };

  const buttonVariant = {
    hidden: { scale: 0.8, opacity: 0 },
    visible: { scale: 1, opacity: 1, transition: { duration: 0.6 } },
  };

  const [currentSlide, setCurrentSlide] = useState(0);
  const images = ["hero2.jpg", "hero.jpg", "hero3.jpg"];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % images.length);
    }, 8000);
    return () => clearInterval(interval);
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentSlide(
      (prevSlide) => (prevSlide - 1 + images.length) % images.length
    );
  };

  return (
    <div className="flex h-screen bg-black text-white relative">
      {/* Image Slider Section */}
      <div className="flex-1 relative flex items-center justify-center overflow-hidden">
        <motion.div
          key={currentSlide}
          className="absolute inset-0 w-full h-full"
          initial={{ opacity: 0, scale: 1.1 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 1.1 }}
          transition={{
            opacity: { duration: 1 },
            scale: { duration: 1 },
            ease: "easeInOut",
          }}
        >
          <motion.img
            src={images[currentSlide]}
            alt="Hero Slide"
            className="w-full h-full object-cover"
          />
        </motion.div>

        {/* Text Section */}
        <div className="relative z-10 px-6 text-left flex flex-col items-start max-w-md sm:max-w-lg">
          <motion.p
            className="text-green-500 font-bold text-sm sm:text-base"
            variants={textVariant}
            initial="hidden"
            animate="visible"
          >
            BEYOND BLOOM
          </motion.p>
          <motion.h1
            className="text-4xl sm:text-6xl md:text-8xl font-extrabold leading-tight mt-4"
            variants={textVariant}
            initial="hidden"
            animate="visible"
          >
            ESPRESSO <br />
            CANDY
          </motion.h1>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.5 }}
          >
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="mt-6 inline-block px-6 py-3 bg-green-400 text-black rounded-lg font-semibold text-lg hover:bg-green-500 transition duration-300"
            >
              <Link to="/cultivars">Explore Cultivars</Link>
            </motion.button>
          </motion.div>
        </div>

        {/* Navigation Buttons */}
        <motion.div
          className="absolute bottom-6 right-12 sm:right-28 flex space-x-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2 }}
        >
          <button
            onClick={prevSlide}
            className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center border-2 border-white bg-black text-white hover:bg-white hover:text-black transition duration-300"
          >
            &larr;
          </button>
          <button
            onClick={nextSlide}
            className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center border-2 border-white bg-black text-white hover:bg-white hover:text-black transition duration-300"
          >
            &rarr;
          </button>
        </motion.div>
      </div>

      {/* Vertical Text */}
      <motion.div
        className="absolute right-0 top-0 h-full bg-black text-green-500 font-bold text-xs sm:text-lg p-4 sm:p-8 flex items-center writing-mode-vertical-rl"
        initial={{ x: 100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <Link to="/cultivars" className="tracking-wide">
          EXPLORE OUR CULTIVARS
        </Link>
      </motion.div>
    </div>
  );
};

export default Herosection;
